module.exports = __webpack_public_path__ + "img/sign-up-banner-background.40fa908b.png";